import React, { useContext, useState } from 'react';
import { useGetProductDetailsQuery } from '../redux-modules/service';
import SessionContext from '../contexts/SessionContext';
import ImageSlider from './components/ImageSlider';
import Sidebar from './components/Sidebar';
import ProductContext from '../contexts/ProductContext';
import ProductInfo from './components/ProductInfo';
import Picture from '../components/ui/Picture/Picture';

export default function ProductDetail({
  productId,
  color,
  type = 'full',
}: { productId: string, color: string, type: 'full' | 'small' }) {
  const session = useContext(SessionContext);
  const [selectedColor, setSelectedColor] = useState<string>(color);
  const { csrfTokenName, csrfTokenValue } = session;

  const handleSelectedColorChange = (newColor: string) => setSelectedColor(newColor);
  let productDetailsBody: any = {
    product: productId,
    color,
  };
  if (csrfTokenName && csrfTokenValue) {
    productDetailsBody = {
      [csrfTokenName]: csrfTokenValue,
      ...productDetailsBody,
    };
  }

  const {
    data: productDetails,
    isLoading: isProductLoading,
    isFetching: isProductFetching,
  } = useGetProductDetailsQuery(productDetailsBody);

  if (isProductLoading || isProductFetching) {
    return null;
  }

  const saleBadgeImage = productDetails?.product?.saleBadgeImage;
  const saleBadgeUrl = productDetails?.product?.saleBadgeUrl;

  return (
    <ProductContext.Provider value={productDetails}>
      <div className="product-holder relative lg:-mx-6 xl:-mx-11.7">
        {saleBadgeImage && (
          <div className="product-sale-badge absolute left-0 top-0 lg:left-6 xl:left-11.7 lg:top-8 xl:top-12 z-10">
            {saleBadgeUrl ? (
              <a href={saleBadgeUrl}>
                <Picture
                  image={saleBadgeImage.url}
                  loading="eager"
                  classes="max-h-8 lg:max-h-16 w-auto"
                />
              </a>
            ) : (
              <Picture
                image={saleBadgeImage.url}
                loading="eager"
                classes="max-h-8 lg:max-h-16 w-auto"
              />
            )}
          </div>
        )}
        <ImageSlider selectedColor={selectedColor} type={type} />
        <Sidebar
          selectedColor={selectedColor}
          handleSelectedColorChange={handleSelectedColorChange}
          type={type}
        />
        <ProductInfo />
      </div>
    </ProductContext.Provider>
  );
}
